var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.36 1.656l3.947 6.579-2.528 2.022c.89 1.508 2.305 3.196 4.008 4.409l2.018-2.523 6.546 4.582L19.054 22H18.5c-5.88 0-10.05-2.244-12.667-5.498-2.593-3.224-3.596-7.359-3.33-11.073l.038-.54L8.36 1.656zm-3.89 4.45c-.107 3.138.81 6.516 2.921 9.142 2.132 2.65 5.54 4.611 10.559 4.745l1.699-2.718-3.454-2.418-1.96 2.45-.75-.45c-2.69-1.614-4.81-4.27-5.88-6.41l-.361-.723 2.449-1.959L7.64 4.344 4.47 6.105z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgZD0iTTguMzYgMS42NTZsMy45NDcgNi41NzktMi41MjggMi4wMjJjLjg5IDEuNTA4IDIuMzA1IDMuMTk2IDQuMDA4IDQuNDA5bDIuMDE4LTIuNTIzIDYuNTQ2IDQuNTgyTDE5LjA1NCAyMkgxOC41Yy01Ljg4IDAtMTAuMDUtMi4yNDQtMTIuNjY3LTUuNDk4LTIuNTkzLTMuMjI0LTMuNTk2LTcuMzU5LTMuMzMtMTEuMDczbC4wMzgtLjU0TDguMzYgMS42NTZ6bS0zLjg5IDQuNDVjLS4xMDcgMy4xMzguODEgNi41MTYgMi45MjEgOS4xNDIgMi4xMzIgMi42NSA1LjU0IDQuNjExIDEwLjU1OSA0Ljc0NWwxLjY5OS0yLjcxOC0zLjQ1NC0yLjQxOC0xLjk2IDIuNDUtLjc1LS40NWMtMi42OS0xLjYxNC00LjgxLTQuMjctNS44OC02LjQxbC0uMzYxLS43MjMgMi40NDktMS45NTlMNy42NCA0LjM0NCA0LjQ3IDYuMTA1eiIKICAgICAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };